import { createSlice } from "@reduxjs/toolkit";

export const assetsSlice = createSlice({
  name: "assets",
  initialState: { assets: [], status: "idle", error: null },
  reducers: {
    setAssets: (state, action) => {
      if (!Array.isArray(action.payload)) return;
      state.assets = action.payload;
      state.status = "ready";
      state.error = null;
    },
    setAssetsStatus: (state, action) => {
      state.status = action.payload?.status || "idle";
      state.error = action.payload?.error ?? null;
    },
    clearAssets: (state) => {
      state.assets = [];
      state.status = "idle";
      state.error = null;
    },
    upsertAsset: (state, action) => {
      const a = action.payload;
      if (!a || typeof a !== "object") return;
      const list = Array.isArray(state.assets) ? state.assets : [];
      const idx = list.findIndex((x) => x.uuid === a.uuid);
      if (idx >= 0) list[idx] = { ...list[idx], ...a };
      else list.unshift(a);
      state.assets = list;
    },
    addFieldsToAssets: (state, action) => {
      const incoming = Array.isArray(action.payload) ? action.payload : [];
      if (incoming.length === 0) return;
      const byAsset = {};
      incoming.forEach((field) => {
        if (!field?.assetUUID) return;
        if (!byAsset[field.assetUUID]) byAsset[field.assetUUID] = [];
        byAsset[field.assetUUID].push(field);
      });
      state.assets = (state.assets || []).map((asset) => {
        const extra = byAsset[asset.uuid];
        if (!extra?.length) return asset;
        const fields = [...(asset.assetFields || [])];
        extra.forEach((field) => {
          if (fields.some((item) => item.uuid === field.uuid)) return;
          fields.push({ ...field, fileDtos: field.fileDtos || [] });
        });
        fields.sort((a, b) =>
          (a.fieldName || "").localeCompare(b.fieldName || ""),
        );
        return { ...asset, assetFields: fields };
      });
    },
  },
});

export const { setAssets, setAssetsStatus, clearAssets, upsertAsset, addFieldsToAssets } =
  assetsSlice.actions;

export default assetsSlice.reducer;
